var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_68429",
    "data-name": "Group 68429",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.905,
    height: 69.646,
    viewBox: "0 0 68.905 69.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7246",
    "data-name": "Rectangle 7246",
    width: 68.905,
    height: 69.646,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68428",
    "data-name": "Group 68428",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44563",
    "data-name": "Path 44563",
    d: "M44.963,23.03,50,36.823,73.343,60.17c-3.557,3.609-7.156,7.177-10.727,10.773L39.083,47.409H36.174V23l-3.3-3.292a3.538,3.538,0,0,1,5-5.008l4.917,4.917a9.362,9.362,0,0,1,2.176,3.411Z",
    transform: "translate(-5.44 -2.336)",
    fill: "#c76f5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44564",
    "data-name": "Path 44564",
    d: "M73.344,60.169,50,36.821,44.964,23.03a9.325,9.325,0,0,0-2.175-3.411L37.872,14.7a3.535,3.535,0,0,0-6.033,2.317c.061,0,.122-.007.184-.007a3.523,3.523,0,0,1,2.5,1.036l4.917,4.917a9.38,9.38,0,0,1,2.174,3.411l5.033,13.791,3.475,3.474q-3.7,3.706-7.4,7.407L56.592,64.915a6.041,6.041,0,0,0,2.319-4.757V56.514a1.692,1.692,0,0,1,2.889-1.2l8.2,8.2Z",
    transform: "translate(-5.441 -2.335)",
    fill: "#b95d4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44565",
    "data-name": "Path 44565",
    d: "M60.544,40.477l-5.915-5.915a9.358,9.358,0,0,0-3.412-2.176L37.426,27.353,12.673,1.214,1.23,12.657l25.61,25.61V51.581A3.016,3.016,0,0,0,29.7,54.62a2.971,2.971,0,0,0,3.077-2.86c0-.036,0-.072,0-.108v3.193a2.971,2.971,0,1,0,5.941,0v1.523a3.018,3.018,0,0,0,2.862,3.04,2.971,2.971,0,0,0,3.077-2.86c0-.036,0-.072,0-.109v1.59a2.97,2.97,0,0,0,5.941,0v-17.5l4.935,4.943a3.537,3.537,0,1,0,5.005-5",
    transform: "translate(-0.21 -0.207)",
    fill: "#ffcdbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44566",
    "data-name": "Path 44566",
    d: "M63.333,42.978a3.534,3.534,0,0,1-2.981,3.493,3.536,3.536,0,0,0-.993-3.056L53.445,37.5a9.344,9.344,0,0,0-3.412-2.174L36.241,30.292,11.489,4.152l2.937-2.937L39.179,27.354,52.97,32.387a9.346,9.346,0,0,1,3.412,2.175L62.3,40.476a3.524,3.524,0,0,1,1.036,2.5Z",
    transform: "translate(-1.963 -0.208)",
    fill: "#fcaf9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44567",
    "data-name": "Path 44567",
    d: "M23.683,47.4a2.971,2.971,0,0,0,2.971,2.971h3.626a2.971,2.971,0,0,0,0-5.941H26.654A2.971,2.971,0,0,0,23.683,47.4",
    transform: "translate(-4.047 -7.592)",
    fill: "#f59482"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44568",
    "data-name": "Path 44568",
    d: "M33.907,47.4a2.971,2.971,0,0,1-2.972,2.971H27.52a2.97,2.97,0,0,0,0-5.94h3.416A2.971,2.971,0,0,1,33.907,47.4Z",
    transform: "translate(-4.703 -7.593)",
    fill: "#e9806f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44569",
    "data-name": "Path 44569",
    d: "M17.912,40.235a2.971,2.971,0,0,0,2.971,2.971H26.94a2.971,2.971,0,0,0,0-5.941H20.883A2.971,2.971,0,0,0,17.912,40.235Z",
    transform: "translate(-3.061 -6.368)",
    fill: "#fcaf9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44570",
    "data-name": "Path 44570",
    d: "M31.066,40.235A2.969,2.969,0,0,1,28.1,43.205H24.68a2.971,2.971,0,0,0,0-5.941H28.1a2.969,2.969,0,0,1,2.97,2.968v0Z",
    transform: "translate(-4.217 -6.368)",
    fill: "#f89f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44571",
    "data-name": "Path 44571",
    d: "M13.647,33.069a2.971,2.971,0,0,0,2.971,2.971h6.127a2.971,2.971,0,0,0,0-5.941H16.618A2.971,2.971,0,0,0,13.647,33.069Z",
    transform: "translate(-2.332 -5.143)",
    fill: "#f59482"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44572",
    "data-name": "Path 44572",
    d: "M26.887,33.068a2.971,2.971,0,0,1-2.971,2.971H20.5a2.97,2.97,0,0,0,0-5.94h3.417a2.971,2.971,0,0,1,2.971,2.969",
    transform: "translate(-3.503 -5.144)",
    fill: "#e9806f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44573",
    "data-name": "Path 44573",
    d: "M8.843,25.9a2.971,2.971,0,0,0,2.971,2.971h4.669a2.971,2.971,0,0,0,0-5.941H11.814A2.971,2.971,0,0,0,8.843,25.9",
    transform: "translate(-1.511 -3.919)",
    fill: "#fcaf9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44574",
    "data-name": "Path 44574",
    d: "M20.323,25.9a2.971,2.971,0,0,1-2.971,2.971H13.936a2.97,2.97,0,1,0,0-5.941h3.417A2.971,2.971,0,0,1,20.323,25.9Z",
    transform: "translate(-2.381 -3.919)",
    fill: "#f89f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44575",
    "data-name": "Path 44575",
    d: "M81.48,67.894l-4.519-4.519a1.02,1.02,0,0,0-1.443,1.443l4.519,4.518a1.02,1.02,0,0,0,1.443-1.442",
    transform: "translate(-12.855 -10.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44576",
    "data-name": "Path 44576",
    d: "M25.609,47.467a1.02,1.02,0,0,0,2.04,0V45.893a3.99,3.99,0,0,0-.373-7.581,3.987,3.987,0,0,0-3.384-6.08,3.987,3.987,0,0,0-3.48-5.941H18.45a3.988,3.988,0,0,0-3.48-5.941h-.05a1.02,1.02,0,0,0,0,2.04h.05a1.95,1.95,0,0,1,0,3.9H10.3a1.95,1.95,0,0,1-.177-3.893,1.02,1.02,0,1,0-.182-2.032,4.014,4.014,0,0,0-1.488.431L1.742,14.083A1.02,1.02,0,0,0,.3,15.526l6.645,6.645A4,4,0,0,0,10.3,28.33h.5a3.989,3.989,0,0,0,3.48,5.941h.056a3.988,3.988,0,0,0,3.48,5.941h1.305a3.987,3.987,0,0,0,3.48,5.941h3v1.313ZM12.335,30.281a1.954,1.954,0,0,1,1.951-1.951h6.127a1.95,1.95,0,0,1,0,3.9H14.285a1.953,1.953,0,0,1-1.951-1.95m3.537,5.941a1.952,1.952,0,0,1,1.95-1.95h6.058a1.95,1.95,0,0,1,0,3.9H17.821a1.953,1.953,0,0,1-1.95-1.951Zm4.785,5.941a1.952,1.952,0,0,1,1.95-1.95h3.626a1.95,1.95,0,0,1,0,3.9H22.606a1.952,1.952,0,0,1-1.951-1.95Z",
    transform: "translate(0 -2.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44577",
    "data-name": "Path 44577",
    d: "M64.751,42.8a4.522,4.522,0,0,0-1.334-3.256L57.5,33.633a10.457,10.457,0,0,0-3.782-2.412L45.75,28.313l-2.908-7.968a10.442,10.442,0,0,0-2.412-3.783l-4.917-4.917a4.554,4.554,0,0,0-7.54,1.764L15.564.305a1.02,1.02,0,0,0-1.481,1.4l24.754,26.14a1.029,1.029,0,0,0,.391.257L53.02,33.137a8.4,8.4,0,0,1,3.04,1.938l5.915,5.916a2.516,2.516,0,0,1,0,3.559l-.026.026a2.528,2.528,0,0,1-3.537-.028L53.477,39.6a1.021,1.021,0,0,0-1.743.721v17.5a1.95,1.95,0,0,1-3.9,0V51.665a1.02,1.02,0,0,0-2.04,0v4.567a1.951,1.951,0,0,1-1.951,1.951l-.072,0a2,2,0,0,1-1.878-2.021V49.626a1.02,1.02,0,0,0-2.04,0v5.012a1.95,1.95,0,1,1-3.9,0V48.15a1.02,1.02,0,1,0-2.04,0v3.294a1.95,1.95,0,0,1-1.95,1.951l-.072,0a2,2,0,0,1-1.878-2.021V50a1.02,1.02,0,0,0-2.04,0v1.375a4.062,4.062,0,0,0,3.846,4.059,3.975,3.975,0,0,0,2.105-.51,3.989,3.989,0,0,0,6.311,2.952A4.02,4.02,0,0,0,43.7,60.219a3.958,3.958,0,0,0,2.458-.735,3.987,3.987,0,0,0,4.927,2.109l7.735,7.733a1.02,1.02,0,1,0,1.48-1.4l-.037-.038L52.8,60.429a3.974,3.974,0,0,0,.973-2.607V42.79l7.794,7.791a1.02,1.02,0,0,0,1.443-1.442L61.1,47.229A4.539,4.539,0,0,0,64.751,42.8M29.811,15.31a2.519,2.519,0,0,1,4.26-2.223L38.988,18a8.4,8.4,0,0,1,1.938,3.04L43.245,27.4l-3.093-1.128S29.814,15.325,29.811,15.31",
    transform: "translate(-2.361 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbIcon);
export default __webpack_public_path__ + "static/media/tb_icon.5fb943edb89aa5f99adea41aab5f13c2.svg";
export { ForwardRef as ReactComponent };